export enum AppRoute {
  Index = '/taxmgmt',
  Placeholder1 = '/placeholder1',
  Placeholder2 = '/placeholder2',
  taxSearch = '/taxmgmt',
}
